// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flex[data-v-7968ece3]{display:flex;align-items:center}.flex.j_cont_sp[data-v-7968ece3]{justify-content:space-between}", ""]);
// Exports
module.exports = exports;
